// extracted by mini-css-extract-plugin
export default {"container":"BrowseCategories_container__u+LNm","cards":"BrowseCategories_cards__Lv66P"};